import React, { useEffect } from "react"

const AdsenseTop = ({ path }) => {
  useEffect(() => {
    ;(window.adsbygoogle = window.adsbygoogle || []).push({})
  }, [path])

  return (
    <ins
      className="adsbygoogle"
      style={{ display: "block" }}
      data-ad-client="ca-pub-7645464084755274"
      data-ad-slot={2461209063}
      data-ad-format="auto"
      data-full-width-responsive="true"
    />
  )
}

export default AdsenseTop
